import React from 'react';

const VI = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_13"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_13)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.25 9L16 9.75L13.75 12L13 11.25L15.25 9Z"
        fill="#0081C6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 9L6 9.75L8.25 12L9 11.25L6.75 9Z"
        fill="#369443"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 9H8V10L6 11L7 9Z"
        fill="#F4C53D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 7H4V10H3V7ZM17 7H18V10H17V7Z"
        fill="#0081C6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 4V3H9V4L10 5V7H11V4ZM4 4L8 5V8L4 5V4ZM17 4L13 5V8L17 5V4ZM8 11L10.5 12L13 11L12 10H9L8 11Z"
        fill="#F4C53D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 6H13V10L10.5 11L8 10V6Z"
        fill="#A60032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 5H13V7H8V5Z"
        fill="#162667"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 7H10V10H9V7ZM11 7H12V10H11V7Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 9H13V10L15 11L14 9Z"
        fill="#F4C53D"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default VI;
